import { render, staticRenderFns } from "./SessionPlanningView.vue?vue&type=template&id=bbcfb330&scoped=true"
import script from "./SessionPlanningView.vue?vue&type=script&lang=js"
export * from "./SessionPlanningView.vue?vue&type=script&lang=js"
import style0 from "./SessionPlanningView.vue?vue&type=style&index=0&id=bbcfb330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcfb330",
  null
  
)

export default component.exports